'use client'

import React,  { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Text,
  List,
  ListItem,
  useToast,
  useColorModeValue,
  useBreakpointValue,
} from '@chakra-ui/react'
import axios from 'axios';
import Footer from '../Footer/Footer';
import avatar from "../../assets/img/user.png";

const contryIcon = {
  "Bénin": "🇧🇯",
  "Burkina Faso": "🇧🇫",
  "Cap-Vert": "🇨🇻",
  "Côte d'Ivoire": "🇨🇮",
  "Gambie": "🇬🇲",
  "Ghana": "🇬🇭",
  "Guinée": "🇬🇳",
  "Guinée-Bissau": "🇬🇼",
  "Libéria": "🇱🇷",
  "Mali": "🇲🇱",
  "Mauritanie": "🇲🇷",
  "Niger": "🇳🇪",
  "Nigeria": "🇳🇬",
  "Sénégal": "🇸🇳",
  "Sierra Leone": "🇸🇱",
  "Togo": "🇹🇬"
}

export default function SocialProfileSimple() {
  const [data, setData] = useState(null);
  const [loginData, setLoginData] = useState({});
  const { id } = useParams();
  const location = useLocation();
  const toast = useToast();
  const breakpoint = useBreakpointValue({ base: '100px', md: '700px' });

  useEffect(() => {
    if (location.state && location.state.loginData) {
      setLoginData(location.state.loginData);
    }
  }, [location.state]);

  const fetchData = async () => {
    try {
      const response = await axios.post(`https://cicabank.com/survey/${id}`, {

      }, {
        headers: {
          'Authorization': `Basic ${btoa(`${location.state.loginData.username}:${location.state.loginData.password}`)}`
        }
      });
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Erreur",
        description: "Une erreur s'est produite. Veuillez recharger la page.",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
      console.error('There was an error!', error);
    }
  }
  if (!data && loginData.username) {
    fetchData();
  }

  return (
    <>
    <Center py={6} flexDirection="column" bg={useColorModeValue('gray.50', 'gray.800')}>
      <Box
        maxW={'320px'}
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        rounded={'lg'}
        p={6}
        textAlign={'center'}>
        <Avatar
          size={'xl'}
          src={avatar}
          mb={4}
          pos={'relative'}
          _after={{
            content: '""',
            w: 4,
            h: 4,
            bg: 'green.300',
            border: '2px solid white',
            rounded: 'full',
            pos: 'absolute',
            bottom: 0,
            right: 3,
          }}
        />
        <Heading fontSize={'xl'} fontFamily={'body'}>
          {data && data.firstName}  {data && data.lastName}
        </Heading>
        <Text fontWeight={600} color={'gray.500'} mb={4}>
          {data && data.email}
        </Text>
        <Text
          textAlign={'center'}
          color={useColorModeValue('gray.700', 'gray.400')}
          px={3}>
          {contryIcon[data && data.country]}  {data && data.country}, {data && data.city}
        </Text>
      </Box>
      <Box textAlign={'start'} mt={10}>
      <List spacing={3}>
        {data?.answer ? Array.from({ length: 20 }, (_, i) => (
          <ListItem key={i}>
            Q: {data && data.answer[i+1]?.Q} <br/>    R: {data && data.answer[i+1]?.R}
          </ListItem>
        )) : 
        <Box minH={breakpoint}>
          <ListItem mt={20} fontSize={'xl'} fontStyle={'bold'}>
            Aucune réponse
          </ListItem>
          </Box>
        }
      </List>
      </Box>
    </Center>
    <Footer />
    </>
  )
}